import { createSlice } from '@reduxjs/toolkit'
import { systemService } from 'app/services/system.service'
import {cloneDeep} from "lodash"

interface System {
  data: {
    // _id: string
    name: string
    licence: string
    apiKey: string
    imageUrlFavicon: string
    imageUrlLogo: string
    iosVersion:string
    androidVersion:string
    inAppBrowserTitle: string;
    inAppBrowsers: Array<{
      name: string;
      url: string;
      isActive: boolean;
      inAppBrowserLogo: string
      isExtraTab:boolean;
    }>
    features: {
      newsFeedEditAndDeleteEnabled:boolean,
      fcmDetailEnabled: boolean,
      fcmUserDetailEnabled: boolean,
      videoCallEnabled:boolean,
      otrEnabled: boolean,
      mfaEnabled:boolean,
      groupWithMembers:boolean,
      isGroupMembersEnabled:boolean,
      captchaEnabled: boolean,
      passwordChangeEnabled: boolean,
      passwordResetEnabled: boolean,
      notificationSound: boolean
    }
    passwordSettings: {
      uppercase: false,
      lowercase: false,
      letter: false,
      number: false,
      mincharactes: 0,
      uniquecharacters: 0,
    },
    fileSizeLimit:string
  }
}

const initialSystemState: System = {
  data: {
    // _id: '',
    name: '',
    licence: '',
    apiKey: '',
    imageUrlFavicon: '',
    imageUrlLogo: '',
    iosVersion: "1.1.0",
    androidVersion:"1.1.0",
    inAppBrowserTitle: "",
    inAppBrowsers: [{
      name: "",
      url: "",
      isActive: false,
      isExtraTab:false,
      inAppBrowserLogo: ""
    }],
    features: {
      newsFeedEditAndDeleteEnabled:false,
      fcmDetailEnabled: false,
      fcmUserDetailEnabled: false,
      videoCallEnabled:false,
      isGroupMembersEnabled:true,
      groupWithMembers:true,
      otrEnabled: false,
      mfaEnabled: false,
      captchaEnabled: false,
      passwordChangeEnabled: false,
      passwordResetEnabled: false,
      notificationSound: true 
    },
    passwordSettings: {
      uppercase: false,
      lowercase: false,
      letter: false,
      number: false,
      mincharactes: 0,
      uniquecharacters: 0,
    },
    fileSizeLimit:"50"
  },
}

export const { actions: systemActions, reducer: systemReducer } = createSlice({
  name: 'system',
  initialState: initialSystemState,
  reducers: {
    updateSystem: (state, action) => {
      const stateData = cloneDeep(state.data)
      state.data = { ...stateData, ...action.payload }
    },
    updateSystemFeatures: (state, action) => {
      const stateData = cloneDeep(state.data)
      state.data = { ...stateData, features: { ...stateData.features, ...action.payload } }
    },
    updatePasswordSettings: (state, action) => {
      state.data.passwordSettings = { ...action.payload }
    },
    updateInAppBrowsers: (state, action) => {
      const stateData = cloneDeep(state.data)
      state.data = { ...stateData, inAppBrowsers: action.payload.inAppBrowsers }
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(systemService.endpoints.getSystem.matchFulfilled, (state, { payload }) => {
      document.title = payload.data.name
      state.data = payload.data
    })
    builder.addMatcher(systemService.endpoints.getConfig.matchFulfilled, (state, { payload }) => {
      document.title = payload.name
      state.data.name = payload.name
      state.data.imageUrlFavicon = payload.imageUrlFavicon
      state.data.imageUrlLogo = payload.imageUrlLogo
    })
  },
})
